import * as _ from 'lodash';

export const columns: any = [
  {
    title: 'List names',
    colSize: '29',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'name',
  },
  {
    title: 'Number of items',
    colSize: '6',
    sortable: true,
    sort: 'desc',
    active: false,
    col: 'count',
    align: 'right',
  },
];
